import * as React from "react";
import { useState } from "react";
import "./button-view-category.less";
import Categories from "../../themes/icons/categories.svg";
import { ModalComponent } from "shared/components/modal/modal";
import { Link as LinkScroll } from "react-scroll";
import { IProductCategoryModel } from "states/menu/menu.models";
import { IconFood } from "themes";
export interface IButtonModalViewCartProps {
  categories: IProductCategoryModel[];
}

export function ButtonModalViewCategory({
  categories,
}: IButtonModalViewCartProps) {
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };
  return (
    <>
      <button
        onClick={handleOpenModal}
        className="button-view-category btn--default  xl:hidden lg:hidden md:visible  sm:visible xs:visible rounded-full bg-white w-14 z-30 space-y-1  fixed bottom-20 left-1"
      >
        <span className="block">
          <img src={Categories} alt="" className="filter-button-category" />
        </span>
      </button>
      <ModalComponent
        portalClassName={`ReactModalPortalViewCategory`}
        isModal={true}
        className="border-1  mx-2 w-3/4 border--primary fixed bottom-36 "
        onOk={handleOpenModal}
        isCustomizeFooter={true}
        onCancel={handleCloseModal}
        title={"MENU"}
        isOpenModal={modalIsOpen}
        onCloseModal={handleCloseModal}
      >
        <ul className="mt-5 category-menu-list space-y-4">
          {categories &&
            categories.map((cate) => (
              <li
                key={cate.id}
                className="uppercase border-b border-gray-100 category-li"
              >
                <LinkScroll
                  activeClass="active"
                  duration={500}
                  spy={true}
                  smooth={true}
                  offset={-100}
                  absolute={true}
                  onClick={handleCloseModal}
                  to={`cate-${cate?.id}`}
                  className={`cursor-pointer flex text-sm uppercase cate-${cate?.id} `}
                >
                  <IconFood className="mr-2" width={20} />
                  {cate.name} ({cate.products.length})
                </LinkScroll>
              </li>
            ))}
        </ul>
      </ModalComponent>
    </>
  );
}
